import PropTypes from "prop-types";
import {
	AppBar,
	Box,
	Grid,
	makeStyles,
	Tab,
	Tabs,
	Typography,
	useTheme,
} from "@material-ui/core";
import React from "react";
import SwipeableViews from "react-swipeable-views";
import Category from "./Category";
import Role from "./Role";
import Services from "./Services";
import UsersToRole from "./UsersToRole";
import Group from "./Group";
import ListGroup from "./ListGroup";
import Initialization from "./initialization";
import SetupEmail from "./SetupEmail";
import ListConfig from "./Config";
import ListPriority from "./ListPriority";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		"aria-controls": `full-width-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: "whitesmoke",
		width: "100%",
	},
}));

export default function MasterTabsDevices() {
	const classes = useStyles();
	const theme = useTheme();
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleChangeIndex = (index) => {
		setValue(index);
	};

	const TablePages = [
		{ labels: "Layanan", components: <Services /> },
		{ labels: "Role", components: <Role /> },
		{ labels: "Users To Role", components: <UsersToRole /> },
		{ labels: "Category", components: <Category /> },
		{ labels: "Group", components: <Group /> },
		{ labels: "List Users Group", components: <ListGroup /> },
		{ labels: "Initialization", components: <Initialization /> },
		{ labels: "Setup Email", components: <SetupEmail /> },
		{ labels: "List Config", components: <ListConfig /> },
		{ labels: "List Priority", components: <ListPriority /> },
	];

	return (
		<div className={classes.root}>
			<AppBar position="static" color="default">
				<Tabs
					value={value}
					onChange={handleChange}
					indicatorColor="primary"
					textColor="primary"
					variant="scrollable"
					scrollButtons="auto"
					aria-label="full width tabs example"
				>
					{TablePages?.map((row, index) => {
						return <Tab label={row.labels} {...a11yProps(index)} />;
					})}
				</Tabs>
			</AppBar>
			<SwipeableViews
				axis={theme.direction === "rtl" ? "x-reverse" : "x"}
				index={value}
				onChangeIndex={handleChangeIndex}
			>
				{TablePages?.map((row, index) => {
					return (
						<TabPanel value={value} index={index} dir={theme.direction}>
							<Grid item>{row.components}</Grid>
						</TabPanel>
					);
				})}
			</SwipeableViews>
		</div>
	);
}
